import React from 'react';
import { useFieldController } from '../../../../helpers/formManager';
import Field from '../../shared/ui/Field';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';

const createFieldName = fieldPathBuilders.desk.uniqueDateRange;

const DeskUniqueRange = ({ deskIndex, disabled }) => {
  const { field } = useFieldController({
    name: createFieldName(deskIndex),
    defaultValue: false,
  });

  return (
    <Field.Memoized
      type={Field.types.checkbox}
      checked={field.value}
      onChange={field.onChange}
      disabled={disabled}
    >
      Уникальный диапазон приема помещений
    </Field.Memoized>
  );
};

export default DeskUniqueRange;
